<template>
<div>
          <h1>Velkommen til Knerten Familiebarnehage</h1>
        <!-- <img alt="Knerten logo" src="../assets/knerten.jpg"> -->
        <img alt="Knerten logo" src="../assets/KnertenBlomst.png"> 
        
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  }
}
</script>

<style scoped>
.home {
  margin-top: 0px;
  background-color: #667CB0;
  /* padding-bottom: 100px; */
}
@media screen and (min-width: 1001px) {
img {
  max-width: calc(115vh - 310px);
    height: auto;
    max-width: auto\9; /* ie8 */
    margin-bottom: 5px;
}
}
@media screen and (max-width: 1000px) {
img {
    max-width: calc(88vh - 350px);
    height: auto;
    max-width: auto\9; /* ie8 */
}
}

</style>

